module.exports = __webpack_public_path__ + "592307b161885ec592c8a896752544a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2124_teaser_image.jpg
// module id = 607
// module chunks = 0